module.exports = __webpack_public_path__ + "img/office-screen-04.9a160a35.jpg";